"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieProps = void 0;
/**
 * ************************************
 *
 * @module next-persist
 * @author most-js
 * @description module that contains function to get state from cookies
 *              this version is run server side
 *
 * ************************************
 */
var cookie_1 = __importDefault(require("cookie"));
function getCookieProps(ctx) {
    // checking if running on build or request
    if (ctx.req === undefined)
        return '';
    else
        return cookie_1.default.parse(ctx.req.headers.cookie || '');
}
exports.getCookieProps = getCookieProps;
